// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SiteLayout from './components/layout/SiteLayout';
import HomePage from './components/HomePage';
import BrandPage from './components/BrandPage';
import ModelPage from './components/ModelPage';
import TranscriptPage from './components/TranscriptPage';
import SearchPage from './components/SearchPage';
import SitemapPage from './components/SitemapPage';
import DisclaimerPage from './components/DisclaimerPage';

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL || '/'}>
      <SiteLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/brand/:brand" element={<BrandPage />} />
        <Route path="/brand/:brand/model/:model" element={<ModelPage />} />
        <Route path="/brand/:brand/model/:model/:transcriptid" element={<TranscriptPage />} />
        <Route path="/search/:searchquery" element={<SearchPage />} />
        <Route path="/sitemap" element={<SitemapPage />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
      </Routes>
      </SiteLayout>
    </Router>
  );
}

export default App;